// removed by extract-text-webpack-plugin
module.exports = {"classQuickLinksContainer":"QuickLinks-classQuickLinksContainer-a0ae949c","classQuickLinksButton":"QuickLinks-classQuickLinksButton-a0fbc38f","classQuickLinksCarousel":"QuickLinks-classQuickLinksCarousel-affa0722"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/QuickLinks.scss
// module id = 851
// module chunks = 0